import Api, { baseURL } from "../Api"

const BASE = `${baseURL("v2")}/{departamento}/produtividade/afastamentos`

export default {
  list(usuarioId) {
    return Api.get(`${BASE}/${usuarioId}`)
  },

  mediaMensal(usuarioId) {
    return Api.get(`${BASE}/${usuarioId}/media-mensal`)
  },

  create(usuarioId, params) {
    return Api.post(`${BASE}/${usuarioId}`, params)
  },

  destroy(id) {
    return Api.delete(`${BASE}/${id}`)
  },
}
